import { VenueId } from "../../venues/venues.types";

export const isVisibleInVenue = (venues: VenueId[], selectedVenue: VenueId): boolean =>
    venues.includes(selectedVenue);
